<span *ngIf="status === 'Inactive'" [attr.label]="status">未激活</span>
<span *ngIf="status === 'Active'" [attr.label]="status">已生效</span>
<span *ngIf="status === 'Expired'" [attr.label]="status">已过期</span>
<span *ngIf="status === 'Disabled'" [attr.label]="status">禁用</span>
<span *ngIf="status === 'Repair'" [attr.label]="status">正在修复</span>
<span *ngIf="status === 'Freeze'" [attr.label]="status">冻结</span>
<span *ngIf="status === 'InfoError'" [attr.label]="status">信息错误</span>
